import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import { WorkItemControl } from "WorkItemTracking/Scripts/Controls/WorkItemForm/WorkItemControl";
import { TestStepsControl } from "../TFS.TestManagement.Controls";

export interface ITestStepsProps {
    workItem: any;
}

/// <reference types="jquery" />

// This is a proxy component to load the edit test case(s) dialog using LegacyComponent
class TestStepsProxy extends React.Component<ITestStepsProps> {
    private _container: HTMLDivElement;
    private _control: WorkItemControl;

    public render(): React.ReactNode {
        if (this._control !== undefined) {
            this._control.bind(this.props.workItem);
        }
        return <div className="test-step-proxy" ref={this._resolveContainerRef}></div>;
    }

    public componentDidMount(): void {
        this._renderControl();
    }

    public componentWillUnmount(): void {
        this._disposeFieldControl();
    }

    private _renderControl(): void {
        this._disposeFieldControl();

        const $controlContainer = $(this._container);

        const testStepsControl: TestStepsControl = new TestStepsControl($controlContainer);
        testStepsControl.setReplatWorkItemFormFlag();
        this._control = testStepsControl;
        // Let the control know it's being used within react
        this._control.bind(this.props.workItem);
    }

    private _disposeFieldControl(): void {
        if (this._control) {
            this._control.unbind();
            this._control.dispose();
            this._control = null;
        }
    }

    private _resolveContainerRef = (element: HTMLDivElement): void => {
        this._container = element;
    };
}

registerLWPComponent("test-steps-proxy", TestStepsProxy);
